module.exports = __webpack_public_path__ + "img/logo_black.d57c2d15.png";